import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SegmentModalFacade } from './segment-modal.facade';
import { SegmentModalStore } from './segment-modal.store';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  TuiAppearance,
  TuiButton,
  TuiDialogContext,
  TuiError,
  TuiLabel, TuiTextfield,
  TuiTextfieldComponent,
  TuiTextfieldDirective
} from '@taiga-ui/core';
import { TuiButtonLoading, TuiChevron, TuiComboBox, TuiDataListWrapperComponent, TuiFilterByInputPipe, TuiTextarea } from '@taiga-ui/kit';
import { TuiForm } from '@taiga-ui/layout';
import { SegmentForm } from './segment-modal.model';
import { injectContext } from '@taiga-ui/polymorpheus';

@Component({
  selector: 'app-segment-modal',
  imports: [
    FormsModule,
    TuiAppearance,
    TuiButton,
    TuiButtonLoading,
    TuiError,
    TuiForm,
    TuiLabel,
    TuiTextfieldComponent,
    TuiTextfieldDirective,
    ReactiveFormsModule,
    TuiTextarea,
    TuiChevron,
    TuiComboBox,
    TuiDataListWrapperComponent,
    TuiFilterByInputPipe,
    TuiTextfield
  ],
  templateUrl: './segment-modal.html',
  styleUrl: './segment-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SegmentModalStore, SegmentModalFacade]
})
export class SegmentModal {
  readonly #fb = inject(FormBuilder);
  protected readonly segmentModalStore = inject(SegmentModalStore);
  readonly #segmentModalFacade = inject(SegmentModalFacade);
  protected readonly context = injectContext<
    TuiDialogContext<
      null,
      {
        platforms: string[];
      }
    >
  >();

  protected readonly segmentForm = this.#fb.group<SegmentForm>({
    platform: this.#fb.nonNullable.control('', [Validators.required]),
    comment: this.#fb.nonNullable.control('', [Validators.required])
  });

  protected buildAudience() {
    if (!this.segmentForm.valid) return;

    this.#segmentModalFacade
      .buildAudience(this.segmentForm)
      .subscribe(() => this.context.completeWith(null));
  }
}
